export default {
  首页: "Heim",
  资产: "Eignir",
  币币: "Staður (Spot)",
  快捷买币: "Fljótleg kaup á dulritunargjaldmiðli",
  "支持多种方式购买，购买更简单": "Kauptu auðveldlega með mörgum greiðslumáta",
  语言设置: "Tungumálastillingar",
  确认恢复: "Staðfesta endurheimt",
  "输入邮箱，方便我们联系您":
    "Sláðu inn netfangið þitt svo við getum haft samband við þig",
  划转: "Færa",
  行情: "Markaður",
  "24H成交": "24h Veltumagn",
  累计收益: "Heildarávöxtun",
  充值时间: "Innborgunardagsetning",
  到期时间: "Gildistími rennur út",
  数量: "Magn",
  操作: "Aðgerð",
  资产信息: "Upplýsingar um eignir",
  复制地址: "Afrita tölu",
  链名称: "Keðjuheiti",
  充值地址: "Innborgunartala",
  收款地址: "Móttökutala",
  账单: "Reikningur",
  提现金额: "Úttektarupphæð",
  接收地址: "Móttökutala",
  交易密码: "Viðskiptalykilorð",
  提现全部: "Taka út allt",
  保存图片: "Vista mynd",
  输入您的交易密码: "Sláðu inn viðskiptalykilorðið þitt",
  确定: "Staðfesta",
  地址: "Tala",
  注册时间: "Skráningardagsetning",
  取消: "Hætta við",
  是否划转: "Færa?",
  登录: "Skrá inn",
  我的地址: "Tölurnar mínar",
  登录密码和交易密码: "Innskráningarlykilorð og viðskiptalykilorð",
  注册: "Skrá mig",
  密码: "Lykilorð",
  设置密码: "Setja lykilorð",
  重复密码: "Endurtaka lykilorð",
  新密码: "Nýtt lykilorð",
  确认新密码: "Staðfesta nýtt lykilorð",
  充值: "Innborgun",
  充值货币: "Innborgun gjaldmiðils",
  合约账户充值: "Innborgun á framtíðarsamningareikning",
  账户充值: "Innborgun á reikning",
  其他: "Annað",
  我的邀请码: "Boðskóðinn minn",
  提现: "Taka út",
  客服: "Þjónustuver",
  持有详情: "Upplýsingar um eignarhlut",
  请输入内容: "Sláðu inn efni",
  邀请好友来领取奖励: "Bjóddu vinum og fáðu umbun",
  复制链接: "Afrita tengil",
  重复设置新的密码: "Endurtaka nýtt lykilorð",
  保存: "Vista",
  我的: "Reikningurinn minn",
  "邮箱/手机号": "Netfang / Símanúmer",
  备注: "Athugasemd",
  地址管理: "Tölustjórnun",
  我的团队: "Hópurinn minn",
  联系我们: "Hafðu samband við okkur",
  竭诚为您服务: "Við erum til þjónustu",
  提取收益: "Taka út ávöxtun",
  带给我的收益: "Mynduð ávöxtun",
  添加: "Bæta við",
  名称: "Heiti",
  添加地址: "Bæta við tölu",
  修改地址: "Breyta tölu",
  可提现: "Hægt að taka út",
  安全中心: "Öryggismiðstöð",
  收益划转: "Færa ávöxtun",
  通知中心: "Tilkynningar",
  "累计收益:": "Heildarávöxtun:",
  注册用户: "Skráðir notendur",
  奖励规则: "Umbunarreglur",
  帮助反馈: "Hjálp og endurgjöf",
  邀请好友: "Bjóða vinum",
  恢复身份: "Endurheimta auðkenni",
  选择语言: "Velja tungumál",
  设置新的密码: "Setja nýtt lykilorð",
  暂无活动: "Engar virkar viðburðir",
  "月增长量(+)": "Mánaðarlegur vöxtur (+)",
  可提取: "Hægt að taka út",
  反馈类型: "Tegund endurgjafar",
  赠送: "Gjöf",
  已经复制: "Afritað",
  保存成功: "Vistað",
  划转成功: "Færsla tókst",
  过期: "Rann út",
  提交成功: "Sent",
  "服务器繁忙，稍后在试": "Þjónn er upptekinn, reyndu aftur síðar",
  全部: "Allt",
  一级: "Stig 1",
  二级: "Stig 2",
  三级: "Stig 3",
  级: "Stig",
  删除成功: "Eytt",
  选择地址: "Veldu tölu",
  不再提醒: "Ekki birta aftur",
  "最小充值金额：": "Lágmarks innborgunarupphæð:",
  选择币种: "Veldu dulritunargjaldmiðil",
  输入投资金额: "Sláðu inn fjárfestingarupphæð",
  输入账户密码: "Sláðu inn reikningslykilorð",
  投资: "Fjárfesta",
  订单编号: "Pöntunarnúmer",
  投资周期: "Fjárfestingartímabil",
  投资资金: "Fjárfest upphæð",
  投资时间: "Fjárfestingartími",
  状态: "Staða",
  投资中: "Virkt",
  已到期: "Rann út",
  暂无数据: "Engin gögn",
  转入: "Færa til",
  邮箱: "Netfang",
  请输入邮箱: "Sláðu inn netfang",
  请输入格式正确的邮箱: "Sláðu inn gilt netfang",
  请输入验证码: "Sláðu inn staðfestingarkóða",
  获取验证码: "Sækja staðfestingarkóða",
  请输入邀请码: "Sláðu inn boðskóða",
  今天: "Í dag",
  昨天: "Í gær",
  最近七天: "Síðustu 7 dagar",
  邀请: "Bjóða",
  购买数量: "Kaupsmagn",
  产品详情: "Upplýsingar um vöru",
  币种: "Dulritunargjaldmiðill",
  利息币种: "Gjaldmiðill ávöxtunar",
  理财类型: "Tegund fjárfestingarvöru",
  产品费率: "Gjöld vöru",
  进行中: "Virkt",
  每天: "Daglega",
  请输入搜索关键词: "Sláðu inn leitarorð",
  通知: "Tilkynningar",
  查看更多: "Sjá meira",
  理财宝: "Fjárfestingarvörur",
  周期: "Lengd",
  年利率: "Ársvextir (APY)",
  更多产品: "Fleiri vörur",
  灵活存取: "Sveigjanlegt sparifé",
  稳定收益: "Stöðug ávöxtun",
  合约指南: "Leiðarvísir fyrir framtíðarsamninga",
  资金划转出: "Útleiðar færsla",
  矿池收益: "Námubætur",
  提现手续费: "Úttektargjald",
  冻结资金: "Fryst fjármagn",
  解冻资金: "Afþýða fryst fjármagn",
  闪兑支出: "Kostnaður við skipti",
  闪兑收入: "Tekjur af skiptum",
  闪兑手续费: "Gjald fyrir skipti",
  合约支出: "Kostnaður við framtíðarsamninga",
  合约收入: "Tekjur af framtíðarsamningum",
  输入的金额不可大于可用金额: "Upphæð má ekki vera hærri en tiltæk upphæð",
  全部兑换成功: "Heildarskipti tókust",
  返回: "Til baka",
  查看历史: "Skoða sögu",
  闪兑历史: "Saga skipta",
  支付: "Greiða",
  获取: "Fá",
  时间: "Tími",
  手续费: "Viðskiptagjald",
  折扣: "Afsláttur",
  价格: "Verð",
  逐仓: "Einangruð framlegð",
  全仓: "Krossframlegð",
  市价委托: "Markaðspöntun",
  限价委托: "Takmörkuð pöntun",
  请输入本金: "Sláðu inn höfuðstól",
  请输入价格: "Sláðu inn verð",
  "可做空/做多": "Hægt að skortsala/langa",
  设置止盈止损: "Setja hagnaðartöku/stöðvunartap",
  止盈价: "Verð fyrir hagnaðartöku",
  止损价: "Verð fyrir stöðvunartap",
  成本: "Kostnaðarverð",
  做多: "Langa",
  做空: "Skortsala",
  仓位信息: "Upplýsingar um stöðu",
  一键平仓: "Loka stöðu (einn smellur)",
  永续: "Ævarandi",
  浮动盈亏: "Óinnleystur hagnaður/tap",
  平仓: "Loka stöðu",
  反向开仓: "Opna öfuga stöðu",
  一键撤销: "Hætta við allt (einn smellur)",
  倍杠杆: "faldur skiptimynt",
  执行价格: "Framkvæmdarverð",
  委托数量: "Magn pantana",
  保证金: "Framlegð",
  成交价: "Framkvæmdarverð",
  创建时间: "Búið til",
  撤销: "Hætta við",
  合约市场: "Markaður framtíðarsamninga",
  交易方向: "Viðskiptastefna",
  委托价格: "Verð pantana",
  委托金额: "Upphæð pantana",
  资金费率: "Fjármögnunarvextir",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Reglulegt gjald greitt af löngum og skammtímastöðum, gert upp á 8ja tíma fresti.",
  "资金费率为正，多方向空方支付资金费用。":
    "Með jákvæðum fjármögnunarvöxtum greiða langar stöður til skammtímastöðva.",
  "资金费率为负，空方向多方支付资金费用。":
    "Með neikvæðum fjármögnunarvöxtum greiða skammtímastöður til langra staða.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Ertu viss um að þú viljir opna öfuga stöðu? Þetta mun kaupa gagnstæða stefnu núverandi stöðu þinnar.",
  "仓位止盈/止损": "Hagnaðartaka/stöðvunartap fyrir stöðu",
  合约名称: "Framtíðarsamningur",
  开仓价格: "Opnunarverð",
  指数价格: "Vísitöluverð",
  止盈设置: "Stillingar hagnaðartöku",
  请输入止盈价: "Sláðu inn verð fyrir hagnaðartöku",
  "当指数价格触达*时，将会触发委托平仓":
    "Þegar vísitöluverð nær * mun lokunarpöntun ræsast.",
  预计盈亏: "Áætlaður hagnaður/tap",
  当前仓位: "Núverandi staða",
  平仓金额: "Lokunarupphæð",
  仓位模式: "Stöðuhamur",
  全仓模式: "Krossframlegðarhamur",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "Í krossframlegðarham er öllu tiltæku fjármagni á framtíðarsamningareikningnum þínum varið sem framlegð. Slit á sér stað þegar tap fer yfir heildarstöðu þína, sem leiðir til taps á allri framlegð þinni og stöðu.",
  逐仓模式: "Einangraður framlegðarhamur",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Tilteknu magni af framlegð er úthlutað til stöðu. Ef framlegðartap fer niður fyrir viðhaldsframlegðarstig er staðan slitin. Þú getur aukið eða minnkað framlegð fyrir þessa stöðu.",
  "是否撤销？": "Hætta við pöntun?",
  "是否一键撤销？": "Hætta við allar pantanir?",
  "是否一键平仓？": "Loka öllum stöðum?",
  持仓保证金: "Framlegð núverandi stöðu",
  风险率: "Áhættuhlutfall",
  未实现盈亏: "Óinnleystur hagnaður/tap",
  可用保证金: "Tiltæk framlegð",
  净值: "Hreint virði",
  账户余额: "Reikningsstaða",
  合约计算器: "Reiknivél framtíðarsamninga",
  交易记录: "Viðskiptasaga",
  "*倍杠杆": "*faldur skiptimynt",
  "平仓盈亏：": "Lokaður hagnaður/tap:",
  时间筛选: "Tímasía",
  仓位类型: "Tegund stöðu",
  订单状态: "Staða pöntunar",
  订单类型: "Tegund pantana",
  平仓价格: "Lokunarverð",
  持仓数量: "Magn stöðu",
  "手续费(%)": "Viðskiptagjald (%)",
  平仓时间: "Lokunartími",
  平仓类型: "Tegund lokunar",
  手动平仓: "Handvirk lokun",
  强制平仓: "Þvinguð slit",
  近1天: "Síðasti dagur",
  近7天: "Síðustu 7 dagar",
  近30天: "Síðustu 30 dagar",
  近180天: "Síðustu 180 dagar",
  持仓: "Opin staða",
  已取消: "Hætt við",
  分时: "Innan dags",
  "24H额(USDT)": "24h magn (USDT)",
  "24H低": "24h lægsta",
  "24H量(BTC)": "24h magn (BTC)",
  "24H高": "24h hæsta",
  "10秒": "10 sekúndur",
  "30秒": "30 sekúndur",
  "1分": "1 mínúta",
  "3分": "3 mínútur",
  "5分": "5 mínútur",
  "30分": "30 mínútur",
  "1小时": "1 klukkustund",
  "4小时": "4 klukkustundir",
  "8小时": "8 klukkustundir",
  "1天": "1 dagur",
  "1周": "1 vika",
  "1月": "1 mánuður",
  单向持仓: "Einátta staða",
  杠杆: "Skiptimynt",
  仓位: "Staða",
  计算结果: "Útkoma",
  盈亏: "Hagnaður/Tap",
  收益率: "Ávöxtun",
  计算结果仅供参考: "Niðurstaðan er leiðbeinandi",
  成交后仓位大小: "Stærð stöðu eftir framkvæmd",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Niðurstaðan er leiðbeinandi, raunverulegar niðurstöður geta verið breytilegar vegna gjalda.",
  目标价格: "Markverð",
  开始计算: "Reikna",
  强平价格: "Slitverð",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Athugaðu vandlega heiti keðjunnar fyrir innborgun. Rangar innborganir er ekki hægt að afturkalla. Lágmarks innborgunarupphæð er *. Innborganir undir þessari upphæð verða ekki afgreiddar. Ekki senda aðrar eignir á þetta tölu. Ekki nota hópfjármögnun eða ICO tölur fyrir úttektir.",
  "最小输入*": "Lágmark {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Lágmarks úttektarmagn er *. Úttektargjöld verða dregin frá úttektarupphæð. Athugaðu vandlega móttökutölu. Ekki senda * á tölur utan *. Ekki nota hópfjármögnun eða ICO tölur.",
  退出登录: "Skrá út",
  加仓: "Auka stöðu",
  新增仓位: "Ný staða",
  输入加仓金额: "Sláðu inn upphæð til að auka stöðu",
  "当前可用:": "Núverandi tiltækt:",
  资产账单: "Reikningur eigna",
  保存二维码: "Vista QR kóða",
  温馨提示: "Athugasemd",
  "请注意：您当前使用的网络": "Athugið: Þú ert að nota netið",
  输入提现地址: "Sláðu inn úttektartölu",
  "可用金额：": "Tiltæk upphæð:",
  输入资产密码: "Sláðu inn lykilorð eigna",
  可用手续费: "Tiltækt gjald",
  "折扣%": "Afsláttur %",
  实扣手续费: "Raunverulega innheimt gjald",
  实际到账: "Raunverulega móttekin upphæð",
  未设置资产密码: "Lykilorð eigna ekki sett",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "Af öryggisástæðum, settu lykilorð eigna áður en þú tekur út.",
  热榜: "Vinsælt",
  涨幅榜: "Mestu hækkanir",
  跌幅榜: "Mestu lækkanir",
  成交额榜: "Magnröðun",
  关于我们: "Um okkur",
  登录密码: "Innskráningarlykilorð",
  设置: "Stillingar",
  资产密码: "Lykilorð eigna",
  修改登录密码: "Breyta innskráningarlykilorði",
  原密码: "Gamalt lykilorð",
  请输入新密码: "Sláðu inn nýtt lykilorð",
  请输入原密码: "Sláðu inn gamalt lykilorð",
  确认密码: "Staðfesta lykilorð",
  确定修改: "Staðfesta breytingu",
  修改资产密码: "Breyta lykilorði eigna",
  验证码: "Staðfestingarkóði",
  资产密码使用提示: "Ábendingar um lykilorð eigna",
  "资产密码用于转移、提取资产和交易。":
    "Lykilorð eigna er notað til að flytja, taka út og eiga viðskipti með eignir.",
  "创建与登录密码不同的资产密码。":
    "Búðu til lykilorð eigna sem er öðruvísi en innskráningarlykilorðið.",
  "定期更改您的资产密码。": "Breyttu lykilorði eigna reglulega.",
  提币历史: "Úttektarsaga",
  "金额/余额": "Upphæð/Staða",
  "手续费/折扣": "Gjald/Afsláttur",
  自选: "Eftirlæti",
  现货: "Staður (Spot)",
  市价: "Markaðsverð",
  止损设置: "Stillingar stöðvunartaps",
  合约K线图: "Graf framtíðarsamninga",
  "24H量": "24h magn",
  "24H额": "24h magn (USDT)",
  合作指南: "Leiðarvísir samstarfsaðila",
  盈亏计算: "Útreikningur hagnaðar/taps",
  当前可用: "Núverandi tiltækt",
  请输入加仓金额: "Sláðu inn upphæð til að auka stöðu",
  请重新输入加仓金额: "Sláðu inn upphæðina til að auka stöðu aftur",
  平仓数量: "Magn til að loka",
  欢迎登录: "Velkominn aftur",
  "忘记密码?": "Gleymt lykilorði?",
  "还没有账号？": "Ertu ekki með reikning?",
  立即注册: "Skrá mig strax",
  繁體中文: "Hefðbundin kínverska",
  找回密码: "Endurheimta lykilorð",
  下一步: "Næsta",
  注册账户: "Skrá reikning",
  "请输入邀请码(选填)": "Sláðu inn boðskóða (valfrjálst)",
  谢邀豪礼: "Boðsbonus",
  "24小时邀请好友排名": "24 tíma boðsröðun",
  "*人": "* manns",
  "差*人": "Vantar * manns",
  "已超过10万人，每月轻松赚钱":
    "Yfir 100.000 notendur, græddu peninga auðveldlega í hverjum mánuði",
  最高: "Hámark",
  邀请链接: "Boðstengill",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Deildu í viðskiptagjöldum sem vinir þínir mynda (staður, framtíðarsamningar, skiptimynt, skipti).",
  平台和您一起分享手续费: "Deildu viðskiptagjöldum með vettvanginum",
  "*级": "* stig",
  规则: "Reglur",
  我的好友: "Vinir mínir",
  好友详情: "Upplýsingar um vin",
  获得好友佣金方案: "Áætlun um þóknun vinar",
  我的等级: "Stig mitt",
  我的邀请数据: "Boðsgögnin mín",
  当前等级: "Núverandi stig",
  平台奖励您: "Vettvangur umbunar þig",
  最高可获取平台奖励: "Hámarks vettvangsumbun",
  邀请规则: "Boðsreglur",
  "邀请*级有效好友": "Bjóddu virka vini á stigi *",
  好友等级: "Stig vinar",
  人: "manns",
  奖金派送: "Útgreiðsla bónuss",
  平台奖励: "Vettvangsumbun",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Vettvangurinn áskilur sér rétt til endanlegrar túlkunar. Við sviksamlega starfsemi verða umbun dregin til baka og reikningurinn þinn frystur. Týndar eignir er ekki hægt að endurheimta.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Reikningurinn þinn verður að vera virkur, skilgreindur sem innborgun að minnsta kosti * USDT að verðmæti í hvaða dulritunargjaldmiðli sem er.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Sá vinur sem þú bauðst verður að vera virkur undirmaður, skilgreindur sem innborgun að minnsta kosti * USDT að verðmæti.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Boðandi og boðaður mega ekki deila sömu IP tölu.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP stig er ákvarðað af fjölda boðinna vina á stigi *.",
  佣金成分: "Þóknunarþættir",
  收益统计: "Ávöxtunartölfræði",
  昨日收益: "Ávöxtun í gær",
  月收益: "Mánaðarleg ávöxtun",
  获取收益: "Fá ávöxtun",
  "总收益：": "Heildarávöxtun:",
  "*级好友": "Vinir á stigi *",
  理财购买: "Kaupa fjárfestingarvöru",
  期限: "Lengd",
  可用金额: "Tiltæk upphæð",
  预估收益: "Áætluð ávöxtun",
  申购上限: "Hámarkskaup",
  项目剩余: "Eftir af verkefni",
  "买入后预计*(SGT)开始计算收益。":
    "Búist er við að ávöxtun hefjist um *(SGT) eftir kaup.",
  计息日: "Upphaf vaxta",
  申购日: "Kaupdagsetning",
  到账日: "Dagsetning inneignar",
  到期自动续投: "Sjálfvirk endurfjárfesting við gildistíma",
  申购: "Kaupa",
  搜索理财项目: "Leita að fjárfestingarvöru",
  超高年化随心选: "Veldu úr vörum með mikla ávöxtun",
  "自由选择理财币种，稳定超额收益":
    "Veldu frjálslega dulritunargjaldmiðilinn þinn fyrir stöðuga, yfir meðallagi ávöxtun",
  理财总资产: "Heildarfjárfestar eignir",
  申购数量: "Magn til að kaupa",
  立即购买: "Kaupa strax",
  年化收益率: "Árleg prósentuávöxtun (APY)",
  理财订单: "Pantannir fjárfestingarvara",
  持有: "Í eigu",
  申购份额: "Keypt hlutur",
  到账日期: "Dagsetning inneignar",
  申购成功: "Kaup tókst",
  到期: "Rann út",
  是否选择做多: "Opna langa stöðu?",
  "可用余额为0 不能操作": "Staða er 0, aðgerð ekki möguleg",
  福利中心: "Bónusmiðstöð",
  奖励记录: "Umbunasaga",
  我获取到的奖励: "Umbun sem ég hef aflað",
  总价值: "Heildarvirði",
  新手任务: "Verkefni fyrir nýja notendur",
  身份认证: "Auðkenning (KYC)",
  身份验证: "Auðkenning",
  去验证: "Auðkenna núna",
  审核中: "Í bið",
  已验证: "Auðkennt",
  认证失败: "Auðkenning mistókst",
  基础认证: "Grunnauðkenning",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Athugið: Auðkenndum upplýsingum er ekki hægt að breyta. Sláðu inn nákvæmar upplýsingar.",
  "国家/地区": "Land/Svæði",
  请选择: "Veldu",
  证件类型: "Tegund skjals",
  证件编码: "Skjalsnúmer",
  身份证: "Persónuskilríki",
  护照: "Vegabréf",
  驾驶证: "Ökuréttindi",
  请输入编码: "Sláðu inn númer",
  名字: "Fornafn",
  请输入: "Sláðu inn",
  中间名: "Miðnafn",
  选填: "Valfrjálst",
  姓氏: "Eftirnafn",
  中国: "Kína",
  身份上传: "Senda inn auðkennisskjal",
  上传身份证: "Senda inn persónuskilríki",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Senda inn í JPG/JPEG/PNG sniði. Gakktu úr skugga um að myndir séu skýrar, heilar og jafnt upplýstar. Hámark *MB.",
  确定提交: "Senda",
  去认证: "Auðkenna",
  挑战任务: "Áskorunarverkefni",
  注册认证任务: "Skráningar- og auðkenningarverkefni",
  完成注册认证即可领取: "Lokið skráningu og auðkenningu til að fá",
  领取奖励: "Fá umbun",
  新人豪礼: "Velkomin bónus",
  "参与人数：": "Fjöldi þátttakenda:",
  条件: "Skilyrði",
  入金量: "Innborgunarupphæð",
  完成: "Lokið",
  任务奖励: "Verkefnaumbun",
  距任务更新: "Þar til verkefni er uppfært",
  "条件：": "Skilyrði:",
  活动规则: "Reglur viðburðar",
  奖励明细: "Upplýsingar um umbun",
  已获得: "Aflað",
  交易奖励: "Viðskiptaumbun",
  Win奖励: "WIN umbun",
  已领取: "Fengið",
  亏损金额超过: "Tapsupphæð fer yfir",
  单笔开仓金额超过: "Stak pöntunarupphæð fer yfir",
  交易量: "Viðskiptamagn",
  待完成: "Í bið",
  入金: "Innborgun",
  盈利金额超过: "Hagnaðarupphæð fer yfir",
  开仓金额: "Pöntunarupphæð",
  开仓金: "Pöntunarupphæð",
  盈利: "Hagnaður",
  亏损: "Tap",
  领取: "Fá",
  未领取: "Ekki fengið",
  待领取: "Í bið til að fá",
  再交易: "Verslaðu áfram",
  即可获得: "til að fá",
  领取成功: "Fengið",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Öllum viðburðum verður gert upp á lokadagsetningu. Umbun rennur út eftir það.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Aflaðri ávöxtun verður bætt við bónusreikninginn þinn, sem þú getur skipt eða tekið út hvenær sem er.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Dulritunargjaldmiðill umbunar fer eftir verkefni.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Vettvangurinn áskilur sér rétt til endanlegrar túlkunar. Við svindl með verkefni verður umbun haldið eftir og reikningurinn þinn gæti verið frystur.",
  成长学院: "Akademía",
  "区块链 & 加密货币": "Blockchain & Dulritunargjaldmiðill",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Alhliða leiðarvísir þinn um dulritunargjaldmiðla. Við fylgjum þér á dulritunarferðalagi þínu.",
  "全仓合约定单的全部保证金。":
    "Heildarframlegð fyrir krossframlegðarpantanir framtíðarsamninga.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Staða + (óinnleystur hagnaður/tap - gjöld - fjármögnunarvextir) = Hreint virði / Notuð framlegð * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Óinnleystur hagnaður/tap hefur bein áhrif á 'tiltæka framlegð'. Ef óinnleystur hagnaður/tap eykst, eykst tiltæk framlegð og öfugt.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Staða - (Notuð framlegð) + (óinnleystur hagnaður/tap - gjöld - fjármögnunarvextir)",
  "注:可继续用于开仓的保证金。":
    "Ath: Framlegð sem er tiltæk til að opna nýjar stöður.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Staða + (óinnleystur hagnaður/tap - gjöld - fjármögnunarvextir)",
  "注:当前的资金结余。": "Ath: Núverandi staða.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Vísar til heildarstöðu framtíðarsamningareikningsins, þar með talið frystar upphæðir.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Ath: Því hærra sem áhættuhlutfallið er, því lægri áhætta, og öfugt.",
  该功能尚未开发: "Þessi aðgerð er enn í þróun",
  重置密码: "Endurstilla lykilorð",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Sláðu inn 8-20 stafi, þar á meðal bókstafi, tölustafi og sérstafi",
  修改成功: "Breyting tókst",
  输入验证码: "Sláðu inn staðfestingarkóða",
  输入密码: "Sláðu inn lykilorð",
  详情说明: "Upplýsingar",
  已售罄: "Uppselt",
  剩余期限: "Eftirstandandi lengd",
  限期: "Lengd",
  闪兑货币选择: "Veldu gjaldmiðil fyrir skipti",
  地区选择: "Veldu svæði",
  "搜索国家/地区": "Leita að landi/svæði",
  "身份信息已提交，将在*小时内审核完成":
    "Auðkennisupplýsingar sendar. Afgreiðsla tekur allt að * klukkustundir.",
  "选择国家/地区": "Veldu land/svæði",
  "止盈价格需高于*": "Verð fyrir hagnaðartöku verður að vera hærra en *",
  "止损价格需低于*": "Verð fyrir stöðvunartap verður að vera lægra en *",
  "止盈价格需低于*": "Verð fyrir hagnaðartöku verður að vera lægra en *",
  "止损价格需高于*": "Verð fyrir stöðvunartap verður að vera hærra en *",
  教程详情: "Upplýsingar um kennsluefni",
  请输入止损价: "Sláðu inn verð fyrir stöðvunartap",
  活期: "Sveigjanlegt",
  赎回后立即到账: "Tafarlaus inneign eftir innlausn",
  赎回: "Leysa út",
  赎回理财: "Leysa út fjárfestingarvöru",
  是否赎回当前的理财订单: "Leysa út núverandi pöntun fjárfestingarvöru?",
  维护: "Viðhald",
  "系统正在维护中……": "Kerfið er í viðhaldi...",
  合约: "Framtíðarsamningar",
  闪电兑换: "Skipti",
  流水挖矿: "Veltumagns námuvinnsla",
  邀请豪礼: "Boðsbonus",
  计算器: "Reiknivél",
  最新价: "Síðasta verð",
  涨跌幅: "Breyting (24h)",
  关注币种添加自选: "Bæta dulritunargjaldmiðli við eftirlæti",
  一键添加自选: "Bæta við eftirlæti (einn smellur)",
  全标已读: "Merkja allt sem lesið",
  无消息: "Engin skilaboð",
  "暂时还没有收到任何消息通知哦!":
    "Þú hefur ekki fengið neinar tilkynningar enn!",
  没有更多数据: "Engin frekari gögn",
  闪兑: "Skipti",
  从: "Frá",
  "可用余额：": "Tiltæk staða:",
  至: "Til",
  预览兑换结果: "Forskoða niðurstöðu skipta",
  闪兑规则: "Reglur um skipti",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Skipti eru háð sveiflum á markaði. Raunverulega móttekin upphæð er bindandi.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Gengi er ákvarðað af þriðja aðila. Vegna kostnaðar og sveiflna getur gengið verið frábrugðið markaðsgengi. Athugaðu vandlega.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Vettvangurinn innheimtir um það bil *% gjald á hver skipti til að standa straum af kostnaði á kauphöllum.",
  确认汇兑: "Staðfesta skipti",
  您预估得到: "Áætluð móttaka",
  汇兑: "Skipti",
  汇兑比例: "Gengi",
  刷新: "Endurnýja",
  兑换: "Skipta",
  没有更多了: "Engin frekari gögn",
  搜索币种: "Leita að dulritunargjaldmiðli",
  可用: "Tiltækt",
  我知道了: "Ég skil",
  最新价格: "Síðasta verð",
  确认: "Staðfesta",
  最大: "Hámark",
  "风险率(%)": "Áhættuhlutfall (%)",
  当前委托: "Núverandi pantanir",
  合作交易历史记录: "Saga viðskipta samstarfsaðila",
  重置: "Endurstilla",
  余额: "Staða",
  现货账户: "Staðarreikningur (Spot)",
  合约账户: "Reikningur framtíðarsamninga",
  WIN账户: "WIN reikningur",
  赏金账户: "Bónusreikningur",
  总资产折合: "Heildareignir (í USDT)",
  今日收益: "Ávöxtun í dag",
  充币: "Innborgun",
  提币: "Úttekt",
  账户权益: "Virði reiknings",
  "数量/类别": "Magn/Flokkur",
  全部币种: "Allir dulritunargjaldmiðlar",
  全部类型: "Allar tegundir",
  账单信息: "Upplýsingar reiknings",
  理财赎回: "Innlausn fjárfestingarvöru",
  购买理财: "Kaupa fjárfestingarvöru",
  收入: "Tekjur",
  支出: "Gjöld",
  到: "til",
  资产划转: "Flutningur eigna",
  "最少*": "Lágmark *",
  "可用资产：": "Tiltækar eignir:",
  确认划转: "Staðfesta flutning",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Þú verður að flytja eignir yfir á réttan reikning til að geta átt viðskipti. Flutningar milli reikninga eru ókeypis.",
  币种账户选择: "Veldu reikning dulritunargjaldmiðils",
  选择账户: "Veldu reikning",
  划转详情: "Upplýsingar um flutning",
  划转明细: "Sundurliðun flutnings",
  收入账单: "Tekjureikningur",
  支出账单: "Gjaldareikningur",
  金额: "Upphæð",
  总收益: "Heildarávöxtun",
  佣金: "Þóknun",
  用户名: "Notandanafn",
  "已领取：": "Fengið:",
  "未领取：": "Ekki fengið:",
  "请选择国家/地区": "Veldu land/svæði",
  请上传身份信息: "Senda inn auðkennisupplýsingar",
  请选择证件类型: "Veldu tegund skjals",
  请填写证件编码: "Sláðu inn skjalsnúmer",
  请填写名字: "Sláðu inn fornafn",
  请填写姓氏: "Sláðu inn eftirnafn",
  投资金额: "Fjárfestingarupphæð",
  天: "dagar",
  请输入手机号: "Sláðu inn símanúmer",
  搜索: "Leita",
  搜索历史: "Leitarsaga",
  热门推荐: "Vinsælar tillögur",
  "《Xspace Earn协议》": "Xspace Earn samningurinn",
  我已了解并同意: "Ég skil og samþykki",
  协议: "Samningur",
  Xspace官方中文交流群: "Opinber kínverskur Xspace hópur",
  Xspace官方英文交流群: "Opinber enskur Xspace hópur",
  预计维护至: "Áætlað viðhald til",
  更多功能: "Fleiri aðgerðir",
  下载APP: "Sækja forrit",
  理财: "Fjárfestingarvara",
  推荐: "Mælt með",
  Telegram官方中文频道: "Opinber Telegram rás (kínverska)",
  Telegram官方英文频道: "Opinber Telegram rás (enska)",
  官方邮箱: "Opinbert netfang",
  客服邮箱: "Netfang þjónustuver",
  上述信息最终解释权归官方所有:
    "Ofangreindar upplýsingar eru háðar opinberri túlkun vettvangsins.",
  IOS版下载: "Sækja fyrir iOS",
  Android版下载: "Sækja fyrir Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Viðskiptagjald = Kaupgjald + Fjármögnunarvextir + Sölugjald",
  资金划转: "Flutningur fjármagns",
  止盈: "Hagnaðartaka",
  止损: "Stöðvunartap",
  自动平仓: "Sjálfvirk lokun",
  委托挂单: "Opin pöntun",
  买: "Kaupa",
  卖: "Selja",
  "买入/做多": "Kaupa/Langa",
  "卖出/做空": "Selja/Skortsala",
  详情: "Upplýsingar",
  浮动涨跌: "Óinnleystur hagnaður/tap",
  最小: "Lágmark",
  充币数量: "Magn innborgunar",
  请输入充币数量: "Sláðu inn magn innborgunar",
  支付截图: "Sönnun greiðslu",
  提交: "Senda",
  上传驾驶证: "Senda inn ökuréttindi",
  上传护照: "Senda inn vegabréf",
  加载中: "Hleð...",
  上传成功: "Innsending tókst",
  充值历史: "Saga innborgana",
  合约卖出手续费: "Sölugjald framtíðarsamninga",
  合约买入手续费: "Kaupgjald framtíðarsamninga",
  系统加款: "Kerfisins inneign",
  系统减款: "Kerfisins skuldfærsla",
  合约资金费率: "Fjármögnunarvextir framtíðarsamninga",
  佣金分成: "Skipting þóknunar",
  U本位合约: "USDT framlegðar framtíðarsamningar",
  资产管理: "Eignastýring",
  APP下载: "Sækja forrit",
  全球领先的数字理财平台:
    "Leiðandi vettvangur heims fyrir stafræna fjárfestingar",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Verslaðu strax með Bitcoin, Ethereum og hundruð annarra stafrænna eigna",
  "24H涨跌幅": "24h breyting",
  查看更多行情: "Sjá fleiri markaði",
  近24小时成交量: "24h magn",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Býður upp á hundruð staðar- og framtíðarsamningapöra. Yfir 20 milljónir notenda í 200+ löndum. Leiðandi vettvangur heims fyrir stafrænar eignir.",
  用户国家分布: "Notendur eftir löndum",
  用户数: "Fjöldi notenda",
  交易对: "Viðskiptapör",
  服务支持: "Þjónusta",
  "随时随地，多平台终端交易":
    "Verslaðu hvar sem er með stuðningi margra vettvanga",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Samhæft við marga tæki fyrir allar viðskiptaþarfir.",
  随时查看实时行情: "Sjáðu rauntímaverð hvar sem er",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Kaupdu og seldu auðveldlega BTC, ETH, DOGE og önnur stafræn eignir",
  获取您关注的加密货币价格变化预警:
    "Fáðu verðviðvaranir fyrir dulritunargjaldmiðla sem þú fylgist með",
  "查看比特币现货、期货、期权价格":
    "Sjáðu Bitcoin staðar-, framtíðar- og kaupréttarverð",
  比较各交易所加密货币价格:
    "Berðu saman verð dulritunargjaldmiðla á milli kauphalla",
  开启您的数字货币之旅: "Byrjaðu ferðalag þitt með stafrænar eignir",
  快捷购买数字货币: "Kaupa dulritunargjaldmiðla fljótt",
  "使用多种支付方式交易数字货币，安全快捷":
    "Verslaðu örugglega og fljótt með mörgum greiðslumáta",
  最优的交易费率: "Bestu viðskiptagjöldin",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Hagstæð gjöld, samkeppnishæf VIP fríðindi og þjónusta af bestu gæðum.",
  可信赖的安全保障: "Áreiðanlegt öryggi",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Háþróuð öryggisráðstafanir og SAFU sjóðurinn vernda eignir þínar fyrir áhættu.",
  交易: "Versla",
  币币市场: "Staðarmarkaður",
  "24H成交量": "24h magn",
  交易所: "Kauphöll",
  "24H最高": "24h hæsta",
  "24H最低": "24h lægsta",
  永续合约: "Ævarandi framtíðarsamningar",
  日涨跌: "Dagleg breyting",
  交易深度: "Dýpt pantanabókar",
  "资产(合约)": "Eignir (Framtíðarsamningar)",
  历史仓位: "Saga staða",
  兑换记录: "Saga skipta",
  类型: "Tegund",
  充值记录: "Saga innborgana",
  划转记录: "Saga flutninga",
  类别: "Flokkur",
  历史账单: "Saga reikninga",
  在线充值: "Innborgun á netinu",
  安全设置: "Öryggisstillingar",
  用于账户登录使用: "Notað til innskráningar á reikning",
  用户提现时安全验证使用: "Notað til öryggissannprófunar við úttektir",
  验证: "Sannprófa",
  万: "milljón",
  随时随地开启交易: "Byrjaðu að versla hvar sem er",
  "*货币交易所的所有功能尽在你的手中。":
    "Allar aðgerðir * dulritunargjaldmiðlakauphallar í þínum höndum.",
  "下载*货币交易所APP。": "Sæktu * dulritunargjaldmiðlakauphallarforritið.",
  下载自: "Sækja frá",
  内测版: "Beta útgáfa",
  下载: "Sækja",
  扫码下载: "Skanna til að sækja",
  设置您的资产密码: "Settu lykilorð eigna þinna",
  法币: "Fiat",
  我要买: "Ég vil kaupa",
  我要卖: "Ég vil selja",
  请输入金额: "Sláðu inn upphæð",
  汇率: "Gengi",
  获得: "Fá",
  支付通道: "Greiðsluleið",
  收款通道: "Móttökuleið",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Gakktu úr skugga um að móttökuleiðin sé á þínu nafni þegar þú selur.",
  当前法币暂不支持交易对可尝试前往提现:
    "Þetta fiat par er ekki stutt eins og er. Prófaðu úttekt.",
  前往提现: "Fara í úttekt",
  该法币暂无通道: "Engin tiltæk leið fyrir þennan fiat gjaldmiðil",
  "正在出售中，请耐心等待": "Sala í gangi, vinsamlegast bíddu",
  请选择支付通道: "Veldu greiðsluleið",
  请选择方式: "Veldu aðferð",
  法币历史: "Fiat saga",
  买币: "Kaupa dulritunargjaldmiðil",
  卖币: "Selja dulritunargjaldmiðil",
  失败: "Mistókst",
  已完成: "Lokið",
  未付款: "Ógreitt",
  待审核: "Í bið",
  打款中: "Greiðsla í gangi",
  订单详情: "Upplýsingar um pöntun",
  联系客服: "Hafðu samband við þjónustuver",
  到账金额: "Móttekin upphæð",
  通道: "Leið",
  收款人: "Viðtakandi",
  收款账户: "Reikningur viðtakanda",
  "订单出售失败，请查下方失败原因":
    "Sala pantana mistókst. Sjá ástæðu hér að neðan.",
  失败原因: "Ástæða mistaka",
  您还未进行付款: "Þú hefur ekki greitt enn",
  您已成功购买: "Kaup tókst",
  已取消订单: "Pöntun hætt við",
  "订单正在审核中，请耐心等待": "Pöntun er í vinnslu. Vinsamlegast bíddu.",
  您已成功出售: "Sala tókst",
  "订单正在打款中，请耐心等待": "Greiðsla í gangi. Vinsamlegast bíddu.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "Til að greiða þarftu að heimsækja annan vettvang. Farðu varlega með upplýsingaöryggi þitt.",
  当前法币暂不支持交易对可尝试前往充值:
    "Þetta fiat par er ekki stutt eins og er. Prófaðu innborgun.",
  前往充值: "Fara í innborgun",
  购买: "Kaupa",
  订单号: "Pöntunarnúmer",
  单价: "Einingarverð",
  到账数量: "Móttekið magn",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Það er ógreidd pöntun. Viltu hefja nýja greiðslupöntun?",
  继续支付: "Halda áfram að greiða",
  重新下单: "Ný pöntun",
  是否确定出售: "Ertu viss um að þú viljir selja?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "Eftir staðfestingu mun vettvangurinn úthluta kaupanda. Bíddu eftir jöfnun.",
  出售: "Selja",
  收款方式: "Móttökuaðferð",
  订单已生成: "Pöntun búin til",
  取消订单: "Hætta við pöntun",
  请在: "Vinsamlegast innan",
  内完成付款: "lokið greiðslu",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Yfirgefðu vettvanginn, skráðu þig inn á valinn greiðslumáta þinn og færðu upphæðina á eftirfarandi reikning seljanda. Tilgreindu alltaf tilvísunina:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Án tilvísunar getur seljandi ekki staðfest greiðsluna, sem getur leitt til taps á eignum.",
  "未在规定的时间内付款，订单都将被取消。":
    "Ef þú greiðir ekki innan tilskilins tíma verður pöntunin hætt við.",
  姓名: "Nafn",
  收款姓名: "Nafn viðtakanda",
  开户支行: "Bankadeild",
  银行卡号: "Bankakortanúmer",
  "付款后，返回本平台": "Eftir greiðslu, farðu aftur á þennan vettvang",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Smelltu á hnappinn 'Ég hef lokið greiðslu, láttu seljanda vita'",
  未点击卖家不会放款:
    "Seljandi mun aðeins gefa út dulritunargjaldmiðilinn eftir að þú hefur smellt á hnappinn",
  交易条款: "Viðskiptaskilmálar",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Fjármagn til kaupa verður að vera löglegt og öruggt",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Svindl, pýramídaleikir, fjárhættuspil eða önnur ólögleg fjármagn eru ekki leyfð",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Ef fjármagn er fryst eða grunað eftir viðskipti, munum við ekki gefa út USDT og munum endurgreiða",
  "已付款，通知卖家": "Greitt, láttu seljanda vita",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Ef þú hættir við samtals * pantanir í dag verður kauprétti þínum fyrir daginn afturkallað. Hætta við þessa pöntun?",
  添加收款方式: "Bæta við móttökuaðferð",
  是否删除此收款方式: "Eyða þessari móttökuaðferð?",
  删除: "Eyða",
  请选择法币: "Veldu fiat gjaldmiðil",
  机构名称: "Heiti stofnunar",
  请选择机构: "Veldu stofnun",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Valin móttökuaðferð þín verður sýnd kaupendum þegar þú selur dulritunargjaldmiðil. Gakktu úr skugga um að gögnin séu rétt.",
  请选择银行: "Veldu banka",
  请输入姓名: "Sláðu inn nafn",
  账号: "Reikningsnúmer",
  请输入账号: "Sláðu inn reikningsnúmer",
  收款码: "Móttökukóði",
  "银行账号/卡号": "Bankareikningur / Kortanúmer",
  "请输入银行账号/卡号": "Sláðu inn bankareikning / kortanúmer",
  "开户支行（选填）": "Bankadeild (valfrjálst)",
  请输入开户支行: "Sláðu inn bankadeild",
  "加入*官方频道": "Vertu meðlimur í opinberu * rásinni",
  关于: "Um",
  条款: "Skilmálar",
  成功: "Tókst",
  等待: "Bíða",
  作废: "Ógilt",
  确认付款: "Staðfesta greiðslu",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Greiðslu lokið? Eftir staðfestingu mun seljandi staðfesta móttöku innan * mínútna.",
  最大金额: "Hámarksupphæð",
  最小金额: "Lágmarksupphæð",
  付款: "Greiða",
  法币充值: "Innborgun fiat",
  法币提现: "Úttekt fiat",
  待支付: "Í bið til greiðslu",
  已支付: "Greitt",
  商户名: "Nafn seljanda",
  当前没有添加支付方式: "Engin greiðsluaðferð bætt við",
  添加后再出售: "Bættu við einni áður en þú selur",
  新人大礼包: "Velkominn pakki",
  注册即可领取: "Fáðu eftir skráningu",
  立即领取: "Fá núna",
  不再提示: "Ekki birta aftur",
  "该奖励需在APP中领取，请下载APP":
    "Þessa umbun er aðeins hægt að fá í forritinu. Sæktu forritið.",
  去交易: "Fara að versla",
  期权交易: "Kaupréttarviðskipti",
  交易额: "Viðskiptaupphæð",
  可用额度: "Tiltæk mörk",
  交易周期: "Viðskiptatímabil",
  看涨: "Bullish (Call)",
  看跌: "Bearish (Put)",
  看空: "Skortsala",
  当前持有: "Núverandi staða",
  胜率: "Sigurhlutfall",
  "盈利/亏损数": "Fjöldi viðskipta með hagnað/tap",
  累计实现盈亏: "Innleystur heildarhagnaður/tap",
  秒: "sekúndur",
  分: "mínútur",
  小时: "klukkustundir",
  周: "vika",
  下单时间: "Tími pantana",
  剩余时间: "Eftirstandandi tími",
  买入价: "Kaupverð",
  结算价: "Uppgjörsverð",
  实现盈利: "Innleystur hagnaður",
  结算时间: "Uppgjörstími",
  期权: "Kaupréttur",
  新手教程: "Leiðarvísir fyrir byrjendur",
  我的订单: "Pantarnir mínar",
  赔率: "Líkindi",
  全部订单: "Allar pantanir",
  持有订单: "Opið pantanir",
  历史订单: "Saga pantana",
  输入交易额度: "Sláðu inn viðskiptaupphæð",
  选择交易周期: "Veldu viðskiptatímabil",
  去注册: "Skrá mig",
  冻结: "Frysta",
  期权支出: "Kostnaður kaupréttar",
  期权收入: "Tekjur kaupréttar",
  用户提现: "Úttekt notanda",
  "是否购买？": "Kaupa þennan kauprétt?",
  购买成功: "Kaup tókst",
  请签名: "Vinsamlegast skrifaðu undir",
  提交签名: "Senda undirskrift",
  清空签名: "Hreinsa undirskrift",
  签名审核中: "Undirskrift í vinnslu",
  已提交: "Sent",
  扫一扫下载APP: "Skannaðu til að sækja forritið",
  新手领取大礼包: "Velkominn pakki fyrir nýja notendur",
  注册实名即送彩金: "Skráðu þig og auðkenndu til að fá bónus",
  交易总额: "Heildarviðskiptamagn",
  资产不足: "Eignir ófullnægjandi",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Ófullnægjandi eignir á WIN reikningi. Þú getur fært eignir af aðalreikningnum þínum.",
  Win: "WIN",
  比赛: "Keppni",
  未开始: "Ekki byrjað",
  赛程: "Dagskrá",
  赛果: "Niðurstaða",
  已结束: "Lokið",
  让球: "Forgjöf",
  进球数: "Mörk",
  大: "Yfir",
  小: "Undir",
  胜负平: "1X2 (Sigur/Jafntefli/Tap)",
  和局: "Jafntefli",
  投注: "Veðmál",
  下注金额: "Veðmálsupphæð",
  下注: "Setja veðmál",
  阵容: "Liðskipan",
  分析: "Greining",
  输入下注金额: "Sláðu inn veðmálsupphæð",
  下注成功: "Veðmál sett",
  投注记录: "Saga veðmála",
  未结算: "Ekki gert upp",
  已结算: "Gert upp",
  流水: "Velta",
  输赢: "Hagnaður/Tap",
  赛时: "Tími leiks",
  下注时间: "Tími veðmáls",
  足彩竞猜: "Knattspyrnuveðmál",
  查看详情: "Skoða upplýsingar",
  输: "Tap",
  赢: "Hagnaður",
  主: "Heimalið",
  客: "Útilið",
  主胜: "Heimasigur",
  客胜: "Útisigur",
  平: "Jafntefli",
  已延期: "Frestað",
  账号异常: "Óeðlilegt á reikningi",
  全场独赢: "Heildarleikur 1X2",
  全场让球: "Heildarleikur Forgjöf",
  全场大小: "Heildarleikur Yfir/Undir",
  总进球: "Heildarmörk",
  拍摄照片要求: "Kröfur um myndatöku",
  标准拍摄: "Staðlað mynd",
  边框缺失: "Vantar ramma",
  照片模糊: "Óskýr mynd",
  闪光强烈: "Of mikill leiftur",
  上传手持证件照: "Senda inn mynd með skjali í hendi",
  上传证件照: "Senda inn mynd af skjali",
  换一张: "Ný mynd",
  出生日期: "Fæðingardagur",
  请选择出生日期: "Veldu fæðingardag",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Sláðu inn staðfestingarkóðann hér að neðan til að fá netfangskóða til skráningar.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Þú átt enn * auðkenningartilraunir eftir. Eftir þessi mörk geturðu ekki auðkennt þig.",
  上半场: "1. hálfleikur",
  下半场: "2. hálfleikur",
  独赢: "1X2",
  上半场独赢: "1. hálfleikur 1X2",
  下半场独赢: "2. hálfleikur 1X2",
  上半场让球: "1. hálfleikur Forgjöf",
  下半场让球: "2. hálfleikur Forgjöf",
  上半场大小球: "1. hálfleikur Yfir/Undir",
  下半场大小球: "2. hálfleikur Yfir/Undir",
  波胆: "Nákvæmlega niðurstaða",
  上半场波胆: "1. hálfleikur Nákvæmlega niðurstaða",
  下半场波胆: "2. hálfleikur Nákvæmlega niðurstaða",
  单双: "Odd/Jafn",
  单: "Odd",
  双: "Jafn",
  上半场单双: "1. hálfleikur Odd/Jafn",
  下半场单双: "2. hálfleikur Odd/Jafn",
  上半场总进球: "1. hálfleikur Heildarmörk",
  下半场总进球: "2. hálfleikur Heildarmörk",
  中场: "Hálfleikur",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Athugið: Fyrir myndina með skjali í hendi, skrifaðu textann á hvítt blað og myndaðu það ásamt skjalinu þínu, eins og í dæminu.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Nýlega hafa margir svikareikningar verið refsað. Hafðu samband við þjónustuver ef þú telur að reikningnum þínum hafi verið refsað óréttilega.",
  最小下注金额: "Lágmarks veðmál",
  参与活动最小下注金额: "Lágmarks veðmál til að taka þátt í viðburðinum",
  记住密码: "Muna lykilorð",
  比分: "Stig",
  "您还未登录，请先登录": "Þú ert ekki skráð(ur) inn. Skráðu þig fyrst inn.",
  立即登录: "Skrá inn núna",
  下注限额: "Veðmálsmörk",
  可赢金额: "Upphæð sem hægt er að vinna",
  闪兑详情: "Upplýsingar um skipti",
  大小球: "Yfir/Undir",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Vegna sveiflna í gengi getur endanleg veðmálsupphæð verið frábrugðin. Pöntunin er bindandi.",
  开赛时间: "Upphafstími",
  足球收入: "Tekjur af knattspyrnu",
  足球支出: "Gjöld vegna knattspyrnu",
  活动详情: "Upplýsingar um viðburð",
  为世界杯喝彩: "Styðjið heimsmeistaramótið",
  我的竞猜: "Ágiskanir mínar",
  "竞猜比赛、有机会瓜分*USDT": "Ágiskaðu á leiki og vinndu hluta af * USDT",
  "瓜分*USDT": "Deildu * USDT",
  距离活动结束还有: "Viðburði lýkur eftir:",
  我的门票: "Miðarnar mínar",
  竞猜结束时间: "Lok ágiskana",
  猜比分: "Ágiska á úrslit",
  "福利派送中，完成任务即可获取门票":
    "Bónusar eru útdeildir. Ljúktu verkefnum til að vinna þér inn miða.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Ljúktu eftirfarandi verkefnum til að fá samsvarandi fjölda miða til að taka þátt í keppninni.",
  时: "klukkustund",
  活动: "Viðburður",
  竞猜记录: "Saga ágiskana",
  结果: "Niðurstaða",
  任务: "Verkefni",
  去邀请: "Bjóða",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Ágiskaðu á úrslit hvers leiks og vinndu hluta af $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "Þú þarft miða til að ágiska. Miða er hægt að vinna sér inn með því að ljúka verkefnum vettvangsins.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "Eftir árangursríka ágiskun skaltu senda skjáskot af niðurstöðunni á þjónustuver. Þeir munu færa bónusinn inn á reikninginn þinn, sem þú getur tafarlaust tekið út.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Svindl er bannað. Ef það uppgötvast verður umbunin ógild.",
  "完成任务后，点击咨询客服获得门票。":
    "Eftir að þú hefur lokið verkefnunum skaltu smella á 'Hafðu samband við þjónustuver' til að fá miða.",
  继续猜: "Halda áfram að ágiska",
  总单数: "Heildarfjöldi veðmála",
  赛事筛选: "Sía eftir viðburði",
  球队筛选: "Sía eftir liði",
  总金额: "Heildarupphæð",
  总流水: "Heildarvelta",
  派奖金额: "Útborguð bónusupphæð",
  下注单数: "Fjöldi veðmála",
  利润: "Hagnaður",
  更多福利: "Fleiri bónusar",
  我的奖金: "Bónusinn minn",
  未认证: "Ekki auðkennt",
  总量: "Heild",
  或: "eða",
  模拟交易: "Uppgerðarviðskipti",
  体验账户不可操作: "Ekki tiltækt á uppgerðarreikningi",
  世界杯比分竞猜: "Ágiskun á úrslitum HM",
  "领*USDT起": "Fáðu frá * USDT",
  消息: "Skilaboð",
  滚球: "Bein veðmál",
  是: "Já",
  不是: "Nei",
  当前余额: "Núverandi staða",
  KOL招募: "KOL ráðning",
  本月净输赢: "Nettó hagnaður/tap þennan mánuð",
  本月佣金: "Þóknun þennan mánuð",
  佣金比例: "Þóknunarhlutfall",
  活跃人数: "Virkir notendur",
  新增下级: "Nýr undirmaður",
  登录人数: "Innskráðir notendur",
  首存人数: "Notendur með fyrstu innborgun",
  数据分析: "Gagnagreining",
  人数: "Fjöldi manns",
  新注册存款金额: "Innborgunarupphæð nýrra skráninga",
  老用户存款金额: "Innborgunarupphæð núverandi notenda",
  首存金额: "Upphæð fyrstu innborgunar",
  快捷入口: "Flýtiaðgangur",
  成员管理: "Meðlimastjórnun",
  财务报表: "Rekstrarreikningar",
  分红报表: "Arðgreiðsluskýrsla",
  订单记录: "Saga pantana",
  VIP专享: "VIP eingöngu",
  推广工具: "Kynningartæki",
  计算规则: "Útreikningsreglur",
  账变明细: "Upplýsingar um færslu",
  成员: "Meðlimir",
  下级概览: "Yfirlit undirmanna",
  下级成员总计: "Undirmenn samtals",
  本月新增: "Nýir þennan mánuð",
  本月活跃会员: "Virkir meðlimir þennan mánuð",
  今日活跃会员: "Virkir meðlimir í dag",
  本月有效活跃: "Árangursríklega virkir þennan mánuð",
  活跃成员占比: "Hlutfall virkra meðlima",
  本月活跃: "Virkir þennan mánuð",
  今日活跃: "Virkir í dag",
  下级成员: "Undirmenn",
  会员账号: "Meðlimareikningur",
  统计时间: "Tölfræðitími",
  筛选: "Sía",
  存款: "Innborgun",
  取款: "Úttekt",
  总输赢: "Heildarhagnaður/tap",
  是否有效用户: "Virkur notandi?",
  最近登录时间: "Síðasta innskráning",
  否: "Nei",
  开始时间: "Upphafstími",
  结束时间: "Lokatími",
  提取: "Taka út",
  总盈亏: "Heildarniðurstaða",
  净盈亏: "Nettó niðurstaða",
  分红: "Arður",
  概览: "Yfirlit",
  月度详细数据: "Mánaðarleg ítarleg gögn",
  未发放: "Ekki útborgað",
  活跃用户: "Virkir notendur",
  有效新增会员: "Árangursríkir nýir meðlimir",
  冲正后净输赢: "Nettó hagnaður/tap eftir leiðréttingu",
  上月结余: "Staða síðasta mánaðar",
  净输赢: "Nettó hagnaður/tap",
  "系统每日新加坡时间1:00更新一次报表":
    "Skýrslur eru uppfærðar daglega klukkan 01:00 að Singapúrstíma.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "Í skýrslum þýða jákvæðar tölur hagnað fyrir samstarfsaðila, neikvæðar tölur þýða tap fyrir samstarfsaðila.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Þóknunargögn eru uppfærð daglega, eru leiðbeinandi og mynda ekki endanlegan grundvöll fyrir útborgun.",
  选择时间: "Veldu tíma",
  足球: "Knattspyrna",
  投注金额: "Veðmálsupphæð",
  有效订单: "Gildar pantanir",
  下级账户: "Reikningur undirmanns",
  待成交: "Í bið",
  下单金额: "Pöntunarupphæð",
  订单内容: "Efni pantana",
  秒数: "Sekúndur",
  联赛: "Deild",
  队伍: "Lið",
  比赛时间: "Leiktími",
  玩法: "Leiktegund",
  等级规则表: "Tafla yfir stigareglur",
  等级: "Stig",
  活跃会员: "Virkir meðlimir",
  最新活跃: "Nýjasta virkni",
  额外佣金: "Aukaþóknun",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Mánaðarlega byggt á vaxtarstöðlum. Þú getur aðeins notið góðs af einu stigi.",
  渠道生成: "Búa til rás",
  创建: "Búa til",
  渠道名称: "Heiti rásar",
  注册人数: "Fjöldi skráninga",
  浏览人数: "Fjöldi skoðana",
  构建状态: "Byggingarstaða",
  禁用: "Gera óvirkt",
  启用: "Gera virkt",
  查看: "Skoða",
  创建渠道: "Búa til rás",
  创建成功: "Búið til",
  操作成功: "Aðgerð tókst",
  渠道详情: "Upplýsingar um rás",
  邀请码: "Boðskóði",
  访问人数: "Fjöldi gesta",
  渠道地址: "Tala rásar",
  我的福利: "Bónusarnir mínir",
  充值福利: "Innborgunarbónus",
  当前流水: "Núverandi velta",
  如何参与: "Hvernig á að taka þátt",
  币种充值: "Innborgun dulritunargjaldmiðils",
  充值福利中领取福利: "Fá bónus í innborgunarbónus",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Regla: Innborgunarbónus er frjáls, gildur í 24 klukkustundir eftir innborgun. Eftir móttöku verður úttekt tímabundið læst þar til veltukröfu er náð.",
  失效日期: "Gildistími rennur út",
  "暂无福利领取，充值后领取": "Enginn bónus í boði. Fáðu eftir innborgun.",
  参与: "Taka þátt",
  充值赠送: "Innborgunarbónus",
  "领取*%的赠送": "Fáðu *% bónus",
  去领取: "Fá",
  VIP奖励: "VIP umbun",
  "当前可领取*USDT，是否确认领取": "* USDT tiltækt til móttöku. Staðfesta?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "Eftir móttöku verður úttekt tímabundið læst þar til * USDT veltu hefur verið náð.",
  充值送大礼: "Innborgunargjöf",
  "存入越多，送越多！": "Því meira sem þú setur inn, því stærri gjöf!",
  无效: "Ógilt",
  有效: "Gilt",
  总存金额: "Heildarinnborguð upphæð",
  提示: "Athugasemd",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Jákvæðar tölur í heildar- og nettóhagnaði/tapi þýða hagnað vettvangs. Dagleg gögn eru leiðbeinandi.",
  "净盈亏：总盈亏-用户返水":
    "Nettó niðurstaða: Heildarniðurstaða - Endurgreiðsla til notanda",
  盈利方: "Hagnaðaraðili",
  代理: "Fulltrúi",
  客户: "Viðskiptavinur",
  平局: "Jafntefli",
  平台: "Vettvangur",
  "已提交审核，请耐心等待": "Sent til auðkenningar. Vinsamlegast bíddu.",
  充值日期: "Innborgunardagsetning",
  平台本月总输赢: "Heildarhagnaður/tap vettvangs þennan mánuð",
  KOL招募合作: "KOL ráðningarsamstarf",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Vettvangurinn opnar KOL ráðningu. Með samfélagsmiðlareikningi geturðu notið arðs og ævilangra tekna með einstakri kynningu á viðskiptavinum.",
  级别: "Stig",
  平台利润返佣: "Þóknun af hagnaði vettvangs",
  佣金案例: "Dæmi um þóknun",
  交易项目: "Viðskiptavörur",
  "期权交易、合约交易、足球游戏":
    "Kaupréttarviðskipti, framtíðarsamningsviðskipti, knattspyrnuleikir",
  报名方式: "Skráningaraðferð",
  点击KOL招募报名: "Smelltu til að skrá þig í KOL ráðningu",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Velkomin(n) í hópinn okkar. Við styðjum þig við að byggja upp þitt eigið notendakerfi. Græddu allt að *% þóknun. Við hlökkum til þátttöku þinnar.",
  输入联系方式: "Sláðu inn tengiliðaupplýsingar",
  最低活跃人数: "Lágmarksfjöldi virkra notenda",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Td: Ef virkir notendur þennan mánuð ≥ * og heildarhagnaður/tap vettvangs ≥ * USDT, tilheyrir þú stigi * og færð *% þóknun.",
  比分竞猜: "Ágiskun á úrslitum",
  豪礼相赠: "Stór gjöf",
  足球活动: "Knattspyrnuviðburður",
  圣诞节活动: "Jólaviðburður",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Þú hefur tekið þátt í viðburði. Úttekt er tímabundið læst. Þú þarft enn * USDT veltu til að opna læsingu.",
  剩余流水: "Eftirstandandi velta",
  助力足球: "Styðjið knattspyrnu",
  佣金累计: "Þóknun samtals",
  有效投注: "Gild veðmál",
  今日: "Í dag",
  今日返水: "Endurgreiðsla í dag",
  VIP返水: "VIP endurgreiðsla",
  返水记录: "Saga endurgreiðslna",
  成员信息: "Upplýsingar um meðlim",
  基本信息: "Grunnupplýsingar",
  钱包余额: "Staða veski",
  投注信息: "Upplýsingar um veðmál",
  返水: "Endurgreiðsla",
  总下注: "Heildarveðmál",
  今日输赢: "Hagnaður/tap í dag",
  下注动态: "Virkni veðmála",
  返水奖励: "Endurgreiðsluumbun",
  分红金额: "Arðsupphæð",
  返水支出: "Gjald endurgreiðslu",
  总返水: "Heildarendurgreiðsla",
  流水总额: "Heildarvelta",
  返水总额: "Heildarendurgreiðsla",
  返水详情: "Upplýsingar um endurgreiðslu",
  日流水: "Dagleg velta",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Vettvangurinn veitir auka endurgreiðslu byggt á daglegri veltu undirmanna þinna. Útgreiðsla daglega klukkan 00:00 að Singapúrstíma á bónusreikning.",
  "申请成功，等待审核": "Umsókn tókst, bið auðkenningar",
  "我出本金，盈利共分享": "Ég gef höfuðstól, hagnaði er deilt",
  最高分红: "Hámarks arður",
  投资大师比赛: "Keppni meistarafjárfesta",
  "我出本金，你盈利": "Ég gef höfuðstól, þú græðir",
  共分享: "Deila saman",
  最高分红可得: "Hámarks mögulegur arður",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Exclusive welcome bonus: $* free. Eftir móttöku geturðu fjárfest í hvaða verkefni sem er. Hagnaður er strax úttektarhæfur.",
  报名领取: "Skráðu þig og fáðu",
  审核驳回: "Auðkenning hafnað",
  驳回原因: "Ástæða höfnunar",
  活动运行周期: "Viðburðartímabil",
  "申请成功后起至*天内完成超额收益。":
    "Náðu umframávöxtun innan * daga frá samþykki.",
  分红比: "Arðshlutfall",
  "*日获得盈利后，可获得*%的收益额。":
    "Eftir að hafa náð hagnaði á degi *, færðu *% af ávöxtunarupphæðinni.",
  参与条件: "Skilyrði fyrir þátttöku",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Notendur frá Rússlandi eða Tyrklandi sem hafa ekki tekið þátt enn.",
  计算项目: "Reiknaðar vörur",
  "合约、体育、期权": "Framtíðarsamningar, Íþróttir, Kaupréttir",
  我的投资: "Fjárfestingar mínar",
  参与天数: "Dagar í þátttöku",
  累计下注: "Heildarveðmál",
  累计盈亏: "Heildarhagnaður/tap",
  预计可分红: "Áætlaður arður",
  常见问题: "Algengar spurningar (FAQ)",
  什么是平台出资: "Hvað er fjármögnun vettvangs?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Vettvangurinn gefur ókeypis fjármagn til notenda frá tilteknum löndum til að fjárfesta í verkefnum.",
  怎么获取平台出资的福利: "Hvernig fæ ég fjármögnunarbónus vettvangs?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Ef þú ert frá einu af tilgreindum löndum skaltu smella á skráningarhnappinn. Eftir samþykki verða * USDT færð á bónusreikninginn þinn, sem þú getur fært til að fjárfesta.",
  什么是分红: "Hvað er arður?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Arður: Ef ávöxtun nær 100% innan tilskilins tíma færðu 50% af umframávöxtun. Dæmi: Fáðu 100 USDT, náðu 120% ávöxtun, þá er 20% umframávöxtun.",
  "如何取得分红？": "Hvernig fæ ég arð?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Viðburðarlotan er á * daga fresti. Að loknu uppgjöri. Ef þú uppfyllir kröfur er arður sendur á bónusreikning. Ef ekki, verður ávöxtun þín og fjármögnun vettvangs fjarlægð.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Tök þátt verða að vera KYC auðkenndir. Aðeins einn bónus á reikning.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC fyrir þátttöku er aðeins gildur fyrir tilgreind lönd. Athugaðu hvort landið þitt passi við viðburðarlandið.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "Eftir árangursríka þátttöku verður úttekt tímabundið læst þar til viðburði er lokið.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Fylgdu reglum viðburðarins. Við svindl eða misnotkun á kerfisvillum verða allar eignir á reikningnum þínum frystar varanlega.",
  平台出资: "Fjármögnun vettvangs",
  平台出资收回: "Fjármögnun vettvangs afturkölluð",
  投资大师奖励: "Umbun meistarafjárfesta",
  请下载APP添加收款方式: "Sæktu forritið til að bæta við móttökuaðferð",
  请下载APP进行身份验证: "Sæktu forritið til að framkvæma auðkenningu",
  请下载APP参与: "Sæktu forritið til að taka þátt",
  技术指标: "Tæknilegar vísbendingar",
  主图: "Aðalgraf",
  副图: "Aukagraf",
  新注册人数: "Nýjar skráningar",
  老用户存款人数: "Núverandi notendur sem leggja inn",
  存款人数: "Fjöldi innborgana",
  取款人数: "Fjöldi úttektar",
  投注人数: "Fjöldi veðmála",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "Að undanskildum notendum frá Indónesíu, Indlandi, Bangladessh sem hafa ekki tekið þátt enn.",
  市场动态: "Markaðsvirkni",
  外汇合约: "Gjaldeyris framtíðarsamningar",
  盈亏比: "Hagnaðar/taps hlutfall",
  委托价: "Verð pantana",
  可用余额: "Tiltæk staða",
  持仓额: "Virði stöðu",
  强平价: "Slitverð",
  修改: "Breyta",
  修改价位: "Breyta verði",
  外汇: "Gjaldeyrir",
  外汇账户: "Gjaldeyrisreikningur",
  我的交易: "Viðskipti mín",
  未设置: "Ekki sett",
  超出最大可设数值: "Fer yfir hámarks stillanlegt gildi",
  超出最小可设数值: "Fer undir lágmarks stillanlegt gildi",
  止盈超出最小可设数值: "Hagnaðartaka fer undir lágmarks stillanlegt gildi",
  止损超出最大可设数值: "Stöðvunartap fer yfir hámarks stillanlegt gildi",
  止盈超出最大可设数值: "Hagnaðartaka fer yfir hámarks stillanlegt gildi",
  止损超出最小可设数值: "Stöðvunartap fer undir lágmarks stillanlegt gildi",
  挖矿: "Námuvinnsla",
  交易账户: "Viðskiptareikningur",
  买涨: "Kaupa (Langa)",
  买跌: "Selja (Skortsala)",
  请输入正确的银行卡信息: "Sláðu inn réttar upplýsingar um bankakort",
  联系在线客服: "Hafðu samband við beinan þjónustuver",
  法币交易请联系在线客服: "Hafðu samband við þjónustuver fyrir fiat viðskipti",
  提交订单: "Senda pöntun",
  "支付过程如有疑问,请联系在线客服":
    "Hafðu samband við þjónustuver ef þú hefur spurningar um greiðsluferlið",
  彩金赠送: "Bónusveiting",
  在线客服: "Bein spjall",
  最少投资: "Lágmarksfjárfesting",
  "提交时间:": "Innsendingartími:",
  提现拒绝: "Úttekt hafnað",
  认证拒绝: "Auðkenning hafnað",
  认证通过: "Auðkenning samþykkt",
  请输入正确的交易额度: "Sláðu inn gilda viðskiptaupphæð",
  最大下注金额: "Hámarks veðmál",
  手机号: "Símanúmer",
  邮箱注册: "Skrá með netfangi",
  手机号注册: "Skrá með símanúmeri",
  查询: "Fyrirspurn",
  手机号登录: "Skrá inn með símanúmeri",
  邮箱登录: "Skrá inn með netfangi",
  请输入数量: "Sláðu inn magn",
  可用数量: "Tiltækt magn",
  钱包登录: "Skrá inn með veski",
  请输入正确的邀请码: "Sláðu inn gildan boðskóða",
  "请输入邀请码(必填)": "Sláðu inn boðskóða (nauðsynlegt)",
  输入正确的金额: "Sláðu inn gilda upphæð",
  法币充值: "Innborgun fiat",
  卢比充值: "Innborgun indverskra rúpía",
  请输入法币: "Sláðu inn fiat upphæð",
  请输入IFSC: "Sláðu inn IFSC kóða",
  "银行编码(选填)": "Bankakóði (valfrjálst)",
  请输入银行编码: "Sláðu inn bankakóða",
  请输入大于8位数的密码: "Sláðu inn lykilorð með fleiri en 8 stöfum",
  添加成功: "Bætt við",
  "60秒": "60 sekúndur",
  "180秒": "180 sekúndur",
  "300秒": "300 sekúndur",
  "2次密码不一致": "Lykilorð stemma ekki",
  输入提币数量: "Sláðu inn úttektarmagn",
  图片格式不正确: "Ógilt myndasnið",
  图片大于20M: "Mynd er stærri en 20 MB",
  请设置委托价格: "Stilltu verð pantana",
  输入资金密码: "Sláðu inn lykilorð eigna",
  验证码错误: "Rangur staðfestingarkóði",
  充值拒绝: "Innborgun hafnað",
  请输入SSN: "Sláðu inn SSN",
  结算完成: "Uppgjöri lokið",
  继续下单: "Halda áfram að panta",
  限价: "Takmörkuð pöntun",
  买入价格: "Kaupverð",
  买入量: "Kaupmagn",
  卖出价格: "Söluverð",
  卖出量: "Sölumagn",
  买入: "Kaupa",
  卖出: "Selja",
  订单创建成功: "Pöntun búin til",
  币币买入支出: "Kostnaður við staðarkaup",
  币币买入支出退还: "Endurgreiðsla kostnaðar við staðarkaup",
  币币买入获得: "Móttaka frá staðarkaupum",
  币币卖出支出: "Kostnaður við staðasölu",
  币币卖出支出退还: "Endurgreiðsla kostnaðar við staðasölu",
  币币卖出获得: "Móttaka frá staðasölu",
  币币交易手续费: "Viðskiptagjald staðar",
  请输入限价: "Sláðu inn takmarkað verð",
  成交: "Framkvæmt",
  等待成交: "Í bið eftir framkvæmd",
  交易完成: "Viðskiptum lokið",
  被取消: "Hætt við",
  交易时间: "Viðskiptatími",
  法币交易: "Fiat viðskipti",
  法币出售: "Fiat sala",

  两次密码不一致: "Lykilorð stemma ekki",
  再次输入账户密码: "Sláðu inn reikningslykilorðið aftur",

  美国: "Bandaríkin",
  韩国: "Suður-Kórea",
  阿尔巴尼亚: "Albanía",
  津巴布韦: "Simbabve",
  赞比亚: "Sambía",
  也门: "Jemen",
  美属维尔京群岛: "Bandarísku Jómfrúaeyjar",
  英属处女群岛: "Bresku Jómfrúaeyjar",
  越南: "Víetnam",
  委内瑞拉: "Venesúela",
  瓦努阿图: "Vanúatú",
  乌兹别克斯坦: "Úsbekistan",
  乌拉圭: "Úrúgvæ",
  英国: "Bretland",
  阿拉伯联合酋长国: "Sameinuðu arabísku furstadæmin",
  乌克兰: "Úkraína",
  乌干达: "Úganda",
  特克斯和凯科斯群岛: "Turks- og Caicoseyjar",
  土库曼斯坦: "Túrkmenistan",
  土耳其: "Tyrkland",
  突尼斯: "Túnis",
  特立尼达和多巴哥: "Trínidad og Tóbagó",
  汤加: "Tonga",
  多哥: "Tógó",
  东帝汶: "Austur-Tímor",
  泰国: "Taíland",
  坦桑尼亚: "Tansanía",
  塔吉克斯坦: "Tadsjikistan",
  中国台湾: "Taívan",
  叙利亚: "Sýrland",
  瑞士: "Sviss",
  瑞典: "Svíþjóð",
  斯威士兰: "Esvatíní",
  苏里南: "Súrínam",
  苏丹: "Súdan",
  斯里兰卡: "Srí Lanka",
  西班牙: "Spánn",
  南非: "Suður-Afríka",
  索马里: "Sómalía",
  所罗门群岛: "Salómonseyjar",
  斯洛文尼亚: "Slóvenía",
  斯洛伐克: "Slóvakía",
  "圣马丁岛（荷兰部分）": "Sint Maarten (hollenski hluti)",
  新加坡: "Singapúr",
  塞拉利昂: "Síerra Leóne",
  塞舌尔: "Seychelleseyjar",
  塞尔维亚: "Serbía",
  塞内加尔: "Senegal",
  沙特阿拉伯: "Sádi-Arabía",
  圣多美和普林西比: "Saó Tóme og Prinsípe",
  圣马力诺: "San Marínó",
  萨摩亚: "Samóa",
  圣克里斯托弗和尼维斯: "Saint Kitts og Nevis",
  圣文森特和格林纳丁斯: "Saint Vincent og Grenadíneyjar",
  圣彼埃尔和密克隆岛: "Saint Pierre og Miquelon",
  圣露西亚: "Saint Lúsía",
  圣基茨和尼维斯: "Saint Kitts og Nevis",
  卢旺达: "Rúanda",
  俄罗斯: "Rússland",
  罗马尼亚: "Rúmenía",
  留尼汪: "Réunion",
  刚果共和国: "Lýðveldið Kongó",
  卡塔尔: "Katar",
  波多黎各: "Púertó Ríkó",
  葡萄牙: "Portúgal",
  波兰: "Pólland",
  菲律宾: "Filippseyjar",
  秘鲁: "Perú",
  巴拉圭: "Paragvæ",
  巴布亚新几内亚: "Papúa Nýja Gínea",
  巴拿马: "Panama",
  巴勒斯坦: "Palestína",
  帕劳: "Palá",
  巴基斯坦: "Pakistan",
  阿曼: "Óman",
  挪威: "Noregur",
  尼日利亚: "Nígería",
  尼日尔: "Níger",
  尼加拉瓜: "Níkaragva",
  新西兰: "Nýja Sjáland",
  新喀里多尼亚: "Nýja Kaledónía",
  荷属安德列斯群岛: "Hollensku Antillaeyjar",
  荷兰: "Holland",
  尼泊尔: "Nepal",
  纳米比亚: "Namibía",
  缅甸: "Mjanmar",
  莫桑比克: "Mósambík",
  摩洛哥: "Marokkó",
  蒙特塞拉特岛: "Montserrat",
  黑山: "Svartfjallaland",
  蒙古: "Mongólía",
  摩纳哥: "Mónakó",
  摩尔多瓦: "Moldóva",
  墨西哥: "Mexíkó",
  马约特: "Mayotte",
  毛里求斯: "Máritíus",
  毛里塔尼亚: "Máritanía",
  马里亚纳群岛: "Maríanaeyjar",
  马提尼克: "Martinique",
  马耳他: "Malta",
  马里: "Malí",
  马尔代夫: "Maldíveyjar",
  马来西亚: "Malasía",
  马拉维: "Malaví",
  马达加斯加: "Madagaskar",
  马其顿: "Norður-Makedónía",
  中国澳门: "Makaó",
  卢森堡: "Lúxemborg",
  立陶宛: "Litháen",
  列支敦士登: "Liechtenstein",
  利比亚: "Líbía",
  利比里亚: "Líbería",
  莱索托: "Lesótó",
  黎巴嫩: "Líbanon",
  拉脱维亚: "Lettland",
  老挝: "Laos",
  吉尔吉斯斯坦: "Kirgistan",
  科威特: "Kúveit",
  基里巴斯: "Kiribatí",
  肯尼亚: "Kenía",
  哈萨克斯坦: "Kasakstan",
  约旦: "Jórdanía",
  日本: "Japan",
  牙买加: "Jamaíka",
  象牙海岸: "Fílabeinsströndin",
  意大利: "Ítalía",
  以色列: "Ísrael",
  爱尔兰: "Írland",
  伊拉克: "Írak",
  伊朗: "Íran",
  印度尼西亚: "Indónesía",
  印度: "Indland",
  冰岛: "Ísland",
  匈牙利: "Ungverjaland",
  中国香港: "Hong Kong",
  洪都拉斯: "Hondúras",
  海地: "Haítí",
  圭亚那: "Gvæjana",
  几内亚比绍共和国: "Gínea-Bissá",
  几内亚: "Gínea",
  危地马拉: "Gvatemala",
  关岛: "Gvam",
  瓜德罗普岛: "Gvadelúp",
  格林纳达: "Grenada",
  格陵兰岛: "Grænland",
  希腊: "Grikkland",
  直布罗陀: "Gíbraltar",
  加纳: "Gana",
  德国: "Þýskaland",
  格鲁吉亚: "Georgía",
  冈比亚: "Gambía",
  加蓬: "Gabon",
  法属波利尼西亚: "Franska Pólýnesía",
  法属圭亚那: "Franska Gvæjana",
  法国: "Frakkland",
  芬兰: "Finnland",
  斐济: "Fídjí",
  法罗群岛: "Færeyjar",
  埃塞俄比亚: "Eþíópía",
  爱沙尼亚: "Eistland",
  厄立特里亚: "Erítrea",
  赤道几内亚: "Miðbaugs-Gínea",
  萨尔瓦多: "El Salvador",
  埃及: "Egyptaland",
  厄瓜多尔: "Ekvador",
  多米尼加共和国: "Dóminíska lýðveldið",
  多米尼加: "Dóminíka",
  吉布提: "Djíbútí",
  丹麦: "Danmörk",
  捷克: "Tékkland",
  塞浦路斯: "Kýpur",
  库拉索: "Curaçao",
  古巴: "Kúba",
  克罗地亚: "Króatía",
  哥斯达黎加: "Kostaríka",
  科特迪瓦: "Fílabeinsströndin",
  库克群岛: "Cooks-eyjar",
  科摩罗: "Kómoreyjar",
  哥伦比亚: "Kólumbía",
  智利: "Síle",
  乍得: "Tsjad",
  中非共和国: "Mið-Afríkulýðveldið",
  佛得角: "Grænhöfðaeyjar",
  开曼群岛: "Caymaneyjar",
  开普: "Cape",
  加拿大: "Kanada",
  喀麦隆: "Kamerún",
  柬埔寨: "Kambódía",
  布隆迪: "Búrúndí",
  布基纳法索: "Búrkína Fasó",
  保加利亚: "Búlgaría",
  文莱: "Brúnei",
  巴西: "Brasilía",
  博茨瓦纳: "Botsvana",
  波斯尼亚和黑塞哥维那: "Bosnía og Hersegóvína",
  玻利维亚: "Bólivía",
  不丹: "Bútan",
  百慕大群岛: "Bermúdaeyjar",
  贝宁: "Benín",
  伯利兹: "Belís",
  比利时: "Belgía",
  白俄罗斯: "Hvíta-Rússland",
  巴巴多斯: "Barbados",
  孟加拉国: "Bangladess",
  巴林: "Barein",
  巴哈马: "Bahamaeyjar",
  阿塞拜疆: "Aserbaídsjan",
  奥地利: "Austurríki",
  澳大利亚: "Ástralía",
  阿鲁巴: "Arúba",
  亚美尼亚: "Armenía",
  阿根廷: "Argentína",
  安提瓜和巴布达: "Antígva og Barbúda",
  安圭拉: "Angvilla",
  安哥拉: "Angóla",
  安道尔: "Andorra",
  美属萨摩亚: "Bandaríska Samóa",
  阿尔及利亚: "Alsír",
  中国: "Kína",
  余额不足: "Ófullnægjandi staða",
  最低购买: "Lágmarkskaup",
  最高购买: "Hámarkskaup",
  下单成功: "Pöntun lögð inn",
  平仓成功: "Stöðu lokað",
  请输入正确的平仓数量: "Sláðu inn gilt magn til að loka",
  加仓成功: "Stöðu aukin",
  请输入正确的加仓金额: "Sláðu inn gilda upphæð til að auka stöðu",
  收藏成功: "Bætt við eftirlæti",
  取消收藏成功: "Fjarlægt úr eftirlæti",
  加密币永续: "Ævarandi dulritunargjaldmiðill",
  外汇永续: "Ævarandi gjaldeyrir",
  期权账户: "Kaupréttarreikningur",
  快捷卖币: "Fljótleg sala á dulritunargjaldmiðli",

  托管资金: "Stýrt fjármagn",
  托管中: "Í stýringu",
  预计日收益: "Áætluð dagleg ávöxtun",
  累计收益: "Heildarávöxtun",
  周期: "Lengd",
  日收益: "Dagleg ávöxtun",
  限额: "Mörk",
  立即托管: "Byrja stýringu núna",
  "已鎖定 請聯繫客服": "Læst. Hafðu samband við þjónustuver.",
  产品列表: "Vörulisti",
  规则: "Reglur",
  创建订单: "Búa til pöntun",
  产品名称: "Heiti vöru",
  托管周期: "Stýringartímabil",
  等级限制: "Stigatakmarkanir",
  托管金额: "Stýrð upphæð",
  限额: "Mörk",
  余额: "Staða",
  购买日: "Kaupdagsetning",
  起息日: "Upphaf vaxta",
  派息时间: "Vaxtagreiðslutími",
  每天: "Daglega",
  计息结束日: "Lok vaxta",
  每日收益: "Dagleg ávöxtun",
  预计收益: "Áætluð ávöxtun",
  "收益将自动发送至您的余额账户;":
    "Ávöxtun verður sjálfkrafa send á stöðu reikningsins þíns;",
  "您的资金没有任何风险;": "Fjármagnið þitt er án áhættu;",
  "365*24小时不断地工作;": "Vinnur 24/7, 365 daga á ári;",
  托管中: "Í stýringu",
  结束: "Lokið",
  今日收益: "Ávöxtun í dag",
  剩余周期: "Eftirstandandi lengd",
  进行中: "Virkt",
  已发放: "Greitt út",
  信誉分: "Trúnaðarstig",

  复制成功: "Afritað með góðum árangri",
  VIP权益: "VIP fríðindi",
  旧密码: "Gamla lykilorðið",
  请输入旧密码: "Vinsamlegast sláðu inn gamla lykilorðið",
  "忘记旧密码请联系客服重置。":
    "Ef þú gleymir gamla lykilorðinu, vinsamlegast hafðu samband við þjónustuver til að endurstilla það.",
  去升级: "Uppfæra",
  描述: "Lýsing",
  实际存款金额: "Raunveruleg innborgunarfjárhæð",
  升级礼金: "Uppfærslubónus",
  隔夜利息: "Næturvextir",
  自动结算: "Sjálfvirk uppgjör",
  等级规则: "Reglur um stig",
  "WEB3.0币持有数据收益": "Gagnaávöxtun af vörslu WEB3.0 mynta",
  总生产: "Heildarframleiðsla",
  有效节点: "Virkir hnútar",
  参与人: "Þátttakendur",
  用户收益: "Ávöxtun notenda",
  "流动性WEB3.0输出": "Úttak lausafjár WEB3.0",
  总资产: "Heildareignir",

  ETHAI持有数据收益: "ETHAI eignarhalds ávöxtun",
  AI量化流动性: "AI megindlegur lausafjárstyrkur",
  现货买入手续费: "Staðfest kaupgjald",
  现货支出: "Staðfest útgjöld",
  现货资金费率: "Staðfest fjármögnunargjald",
  现货卖出手续费: "Staðfest sölugjald",
  现货收入: "Staðfestar tekjur",
  外汇合约支出: "Gjaldeyrissamnings útgjöld",
  外汇合约买入手续费: "Gjaldeyrissamnings kaupgjald",
  外汇合约资金费率: "Gjaldeyrissamnings fjármögnunargjald",
  外汇合约卖出手续费: "Gjaldeyrissamnings sölugjald",
  外汇合约收入: "Gjaldeyrissamnings tekjur",
  理财购买: "Fjárfestingarkaup",
  VIP理财日收益: "VIP fjárfestingar dagleg ávöxtun",
  VIP理财隔夜利息: "VIP fjárfestingar yfirnæturvextir",
  VIP本金返还: "VIP endurgreiðsla höfuðstóls",
  VIP彩金发放: "VIP útborgun bónus",
  VIP彩金抵扣: "VIP bónusafsláttur",
  隔夜利息: "Yfirnæturvextir",
  设置资产密码: "Setja eignalykilorð",

  锁仓挖矿: "Læst námuvinnsla",
  一站式理财服务: "Heildstæð fjármálaþjónusta",
  产品: "Vörur",
  客服中心: "Þjónustuver",
  贷款: "Lán",
  挖矿赚不停: "Stöðugar tekjur af námuvinnslu",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Læst námuvinnsla felst í því að fela USDT (USD:1USDT=1USD) undir ofurtölvunámubúnað vettvangsins til að afla tekna í námulaug vettvangsins.",
  产品优势: "Kostir vörunnar",
  随存随取: "Leggja inn og taka út hvenær sem er",
  锁仓周期: "Læsingartímabil",
  每日下发: "Dagleg úthlutun",
  随机空投: "Handahófskennd loftdrop",
  "100%资金安全保障": "100% öryggi fjármuna",
  "100%节假日收益不间断": "100% samfelldur hagnaður jafnvel á frídögum",
  成功锁仓后当天产出: "Framleiðsla hefst sama dag og læsing tekst",
  关于违约金: "Um samningsbrotasektir",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Ef þú vilt taka út höfuðstól áður en bindingartíma lýkur verður innheimt samningsbrotasekt. Samningsbrotasekt = uppgjörshlutfall samningsbrots × dagar sem eftir eru × læst upphæð.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Dæmi: Uppgjörshlutfall samningsbrots fyrir þessa læstu námuvinnslu er 5%, 3 dagar eru eftir til loka og læst upphæð er 10000U (USDT/USD). Þá er samningsbrotasekt = 5%×3×10000=1500U og raunverulegur endurgreiddur höfuðstóll er 15000U-1500U.",
  收益计算: "Útreikningur tekna",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Vettvangurinn býður upp á ýmsar læstar námuvinnslu-fjárfestingarvörur fyrir notendur. Útreikningur tekna er sem hér segir, til dæmis:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Ef meðlimur læsir 10000U (USDT, USD) á vettvanginum og velur 7 daga fjárfestingarvöru með daglegri ávöxtun 0,7%~1,8% af læstri upphæð, verður daglegur hagnaður sem hér segir:",
  "最低:10000Ux0.7%=70U;": "Lágmark: 10000U×0,7%=70U;",
  "最高:10000Ux1.8%=180U;": "Hámark: 10000U×1,8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "Eftir 7 daga er hægt að fá 490U~1260U í hagnað. Tekjur eru greiddar daglega og læstur höfuðstóll færist sjálfkrafa inn á fjármálareikning þinn við lok bindingartíma.",
  正在托管的资金: "Fjármunir í vörslu",
  签到: "Innskráning",
  锁仓订单: "Læsingarpantanir",
  预计今日收益: "Áætlaðar tekjur í dag",
  累计收益: "Samanlagðar tekjur",
  托管中的订单: "Pantanir í vörslu",
  单笔最少: "Lágmarksupphæð á færslu",
  单笔最多: "Hámarksupphæð á færslu",
  日收益率: "Dagleg ávöxtun",
  说明: "Skýring",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Tölfræðitími miðast við GMT+8<br>2. Dagleg hagnaðargildi eru reiknuð út frá öllum uppgerðum pöntunum milli 00:00-23:59 GMT+8 (staðartími 00:00-23:59)<br>3. Tekjur dagsins verða sameiginlega greiddar út næsta dag milli 00:00-00:10 GMT+8.",
  知道了: "Skilið",
  锁仓: "Læsa",
  派息时间: "Útborgunartími",
  每日: "Daglega",
  托管资金: "Fjármunir í vörslu",
  到期返回: "Skilað við lok tíma",
  提前赎回: "Fyrirfram innlausn",
  预计收益: "Áætlaðar tekjur",
  认购: "Áskrift",
  热门: "Vinsælt",
  数字货币: "Rafmyntir",
  贵金属: "Eðalmálmar",
  大宗商品: "Hrávörur",
  持仓明细: "Stöðuyfirlit",
  历史明细: "Söguleg yfirlit",
  当前价: "Núverandi verð",
  "↑买涨": "↑ Kaupa hækkun",
  "↓买跌": "↓ Kaupa lækkun",
  显示全部: "Sýna allt",
  买入金额: "Kaupupphæð",
  方向: "Stefna",
  收益: "Tekjur",
  预期收益: "Væntanlegar tekjur",
  估用保证金: "Áætluð trygging",
  确认下单: "Staðfesta pöntun",
  锁定: "Læst",
  账户总资产: "Heildareignir reiknings",
  明细: "Yfirlit",
  今日收益: "Tekjur dagsins",
  仓位保证金: "Trygging stöðu",
  持有仓位: "Opnar stöður",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Læst upphæð = samtala allra ólokinna pantana í læstri námuvinnslu",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Tölfræðitími miðast við GMT+8<br>2. Dagleg hagnaðargildi eru reiknuð út frá öllum uppgerðum pöntunum milli 00:00-23:59 GMT+8 (staðartími 00:00-23:59)",
  充值方式: "Innborgunaraðferð",
  银行汇款: "Bankamillifærsla",
  "银行汇款请联系客服进行操作!":
    "Vinsamlegast hafðu samband við þjónustuver til að framkvæma bankamillifærslu!",
  提款方式: "Úttektaraðferð",
  "银行提款请联系客服进行操作!":
    "Vinsamlegast hafðu samband við þjónustuver til að framkvæma bankaúttekt!",
  资金明细: "Fjárhagsyfirlit",
  提现记录: "Úttektarskrá",
  拒绝: "Hafnað",
  通过: "Samþykkt",
  拒绝原因: "Ástæða höfnunar",

  消息公告: "Tilkynningar",
  订单: "Pantanir",
  个人中心: "Persónulegt svæði",
  "未到期赎回需支付一定的违约金!":
    "Við snemmbæra innlausn þarf að greiða sekt.",

  请输入区号: "Vinsamlegast sláðu inn svæðisnúmer",
  "请选择国家/地区": "Vinsamlegast veldu land/svæði",

  今日开盘: "Opnun dagsins",
  昨日收盘: "Lokun gærdagsins",

  实名认证即送: "Fáðu strax við staðfestingu á auðkenni",
  立即认证: "Staðfesta núna",
  新用户礼包: "Velkominargjöf fyrir nýja notendur",
  完成新人任务领取: "Ljúktu verkefnum fyrir nýja notendur til að sækja gjöfina",
  认证: "Staðfesta",
  时间周期: "Tímabil",
  支付金额: "Greiðsluupphæð",
  已平仓: "Lokað",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "MGBX velkominargjöf fyrir nýja notendur: Hver notandi getur að hámarki fengið",
  我已经阅读并同意: "Ég hef lesið og samþykki",
  隐私政策: "Persónuverndarstefna",

  放弃奖励离开: "Hætta við verðlaunin og fara",
  继续注册: "Halda áfram skráningu",
  分钟: "Mínútur",
  "请先勾选隐私政策!": "Vinsamlegast kynntu þér persónuverndarstefnuna fyrst!",
  添加其他到自选: "Bæta öðrum við vaktlista",
  充值最高可得: "Fylltu á og fáðu allt að 30.000 dali.",

  请输入格式正确的手机号: "Vinsamlegast sláðu inn gilt farsímanúmer.",
  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 冰岛



// WEBPACK FOOTER //
// ./src/lang/bd.js